import RequestBase from "./RequestBase.ts";

export default class GroupUsersRequests extends RequestBase {
    constructor(){
        super("GroupUsers/");
    }

    GetForGroup (groupId, onSuccess) {
        this.defaultAxios.get(`GetForGroup/${groupId}`)
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }
}